<template>
  <a-drawer
    :title="formRecord.name||''"
    :maskClosable="true"
    width="100%"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    >
    <a-card :bordered="false">

      <a-row :gutter="20">
        <a-col :span="edit?16:24" >
          <!-- 查询区域 -->
          <div style="margin-bottom: 20px">
            <a-button v-if="edit" @click="handleAddMy" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
            <a-button v-if="edit" @click="handleAddByFormCopy({})" type="primary" icon="plus" style="margin-left: 8px">从已有表单新增</a-button>
            <a-button v-else @click="handleEditCreate" type="primary" style="margin-left: 8px">更改配置</a-button>
            <a-button @click="handleResetSortNum" type="primary" style="margin-left: 8px">自动排序</a-button>
            <a-button @click="handleSetNum" type="primary" style="margin-left: 8px">自动设置题号</a-button>
          </div>

          <!-- table区域-begin -->
          <div class="table">
            <a-table
              ref="table"
              size="middle"
              :customRow="customRowFn"
              :expandedRowKeys.sync="expandedRowKeys"
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="false"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange">
              <span slot="check" slot-scope="text, record" v-if="edit">
                <a-radio :checked="record.id===model.id || record.id===coppyId"></a-radio>
              </span>
              <span slot="action" slot-scope="text, record" v-if="edit">
          <a @click="handleEditMy(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAddByFormCopy(record)">从已有表单新增</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleAddMyCopy(record)">复制新增</a>
              </a-menu-item>
               <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete2(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

            </a-table>
            <!-- 表单区域 -->
          </div>
        </a-col>
        <a-col :span="8" v-if="edit">
          <div style="line-height: 50px;text-align: center;font-size: 18px">
            元素编辑
          </div>
          <a-spin :spinning="confirmLoading">
            <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 8 },wrapperCol: { span: 16 },}" ref="ruleForm" :rules="rules">

              <a-form-model-item
                label="ID">
                <a-input  readOnly v-model="model.id" />
              </a-form-model-item>
              <a-form-model-item
                prop="number"
                label="题号">
                <a-input :rows="2" placeholder="请输入题号" v-model="model.number" />
              </a-form-model-item>
              <a-form-model-item
                prop="name"
                label="题目">
                <a-textarea :rows="2" placeholder="请输入题目" v-model="model.name" />
              </a-form-model-item>
              <a-form-model-item
                prop="category"
                label="必填">
                <a-radio-group v-model="model.required" @change="categoryChange">
                  <a-radio value="1">是</a-radio>
                  <a-radio value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="题目图片">
                <j-image-upload  class="avatar-uploader" text="上传" v-model="model.img" :bizPath="`${formRecord.projectId}/form/${formRecord.id}`"> </j-image-upload>
              </a-form-model-item>
              <a-form-model-item
                label="需要用户画图">
                <a-radio-group v-model="model.draw">
                  <a-radio value="1">是</a-radio>
                  <a-radio value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                prop="category"
                label="元素库">
                <a-radio-group v-model="model.category" @change="categoryChange">
                  <a-radio value="1">公共元素库</a-radio>
                  <a-radio value="2">项目元素库</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                prop="category"
                label="量表元素">
                <a-radio-group v-model="model.scale" >
                  <a-radio value="1">是</a-radio>
                  <a-radio value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                prop="category"
                label="隐藏元素">
                <a-radio-group v-model="model.conceal" @change="concealChange">
                  <a-radio value="1">是</a-radio>
                  <a-radio value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                prop="disabled"
                label="禁止输入">
                <a-radio-group v-model="model.disabled" >
                  <a-radio value="1">是</a-radio>
                  <a-radio value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                prop="elementId"
                label="元素">
                <a-tree-select
                  v-model="model.elementId"
                  :key="treeKey"
                  :replaceFields="replaceFields"
                  :tree-data="elTreeData"
                  :load-data="onLoadTreeData"
                  :treeExpandedKeys.sync="expandedKeys"
                  show-search
                  style="width: 100%"
                  :filterTreeNode="filterTreeNode"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  placeholder="请选择元素"
                  @change="elTreeChange"
                >
                </a-tree-select>
              </a-form-model-item>
              <a-form-model-item
                prop="sortNum"
                label="排序">
                <a-input-number v-model="model.sortNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入排序" />
              </a-form-model-item>
              <a-form-model-item
                prop="parentId"
                label="依赖项">
                <a-tree-select
                  v-model="model.parentId"
                  :replaceFields="replaceFields"
                  :tree-data="itemTreeData"
                  show-search
                  allowClear
                  style="width: 100%"
                  :filterTreeNode="filterTreeNode"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  placeholder="请选择依赖项"
                  tree-default-expand-all
                  @change="itemTreeChange"
                >
                </a-tree-select>
              </a-form-model-item>
              <a-form-model-item
                v-if="model.parentId"
                prop="parentValueList"
                label="依赖项值">
                <a-select placeholder="请选择依赖项值" v-model="model.parentValueList" mode="multiple">
                  <a-select-option v-for="(item,index) in currentDictItems" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                prop="description"
                label="描述">
                <a-textarea :rows="2" placeholder="请输入描述" v-model="model.description" />
              </a-form-model-item>
              <a-form-model-item
                prop="inputTip"
                label="引导语">
                <a-textarea :rows="2" placeholder="请输入引导语" v-model="model.inputTip" />
              </a-form-model-item>
            </a-form-model>
            <div style="text-align: right">
              <a-button @click="handleCancel">关闭</a-button>
              <a-button type="primary" style="margin-left: 30px" @click="handleSubmit">保存</a-button>
            </div>
          </a-spin>
        </a-col>
      </a-row>
      <!-- table区域-end -->
    </a-card>
    <a-modal
      title="更改说明"
      :width="800"
      :visible="editVisible"
      :confirmLoading="confirmLoading"
      switchFullscreen
      @ok="handleEditOk"
      @cancel="handleEditCancel"
      cancelText="关闭">
      <a-spin :spinning="confirmLoading">
        <a-form-model layout="horizontal" :model="editModel" v-bind="{labelCol: { span: 8 },wrapperCol: { span: 16 },}" ref="editRuleForm" :rules="editRules">
          <a-form-model-item
            prop="category"
            label="是否需要保存历史版本">
            <a-radio-group v-model="editModel.isEdit" >
              <a-radio value="1">是</a-radio>
              <a-radio value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            v-if="editModel.isEdit==='1'"
            prop="description"
            label="修改原因/说明">
            <a-textarea :rows="2" placeholder="请输入修改原因/说明" v-model="editModel.description" />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <a-modal
      title="已有表单新增"
      :width="800"
      :visible="addByFormVisible"
      :confirmLoading="confirmLoading"
      switchFullscreen
      @ok="handleAddByFormOk"
      @cancel="handleAddByFormCancel"
      cancelText="关闭">
      <a-spin :spinning="confirmLoading">
        <a-form-model layout="horizontal" :model="addByFormModel" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 20 },}" ref="editRuleForm" >
          <a-form-model-item
            label="依赖项">
            <a-tree-select
              v-model="addByFormModel.parentId"
              :replaceFields="replaceFields"
              :tree-data="addByFormItemTreeData"
              show-search
              allowClear
              style="width: 100%"
              :filterTreeNode="filterTreeNode"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              @change="itemTreeChange2"
              placeholder="请选择"
              tree-default-expand-all
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item
            v-if="addByFormModel.parentId"
            prop="parentValueList"
            label="依赖项值">
            <a-select placeholder="请选择依赖项值" v-model="addByFormModel.parentValueList" mode="multiple">
              <a-select-option v-for="(item,index) in addByFormModel.dictItems" :key="index" :value="item.value">{{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            label="已有表单">
            <a-select v-model="addByFormModel.formId" placeholder="请选择" @change="formIdChange" showSearch
                      :filterOption="filterOption"
            >
              <a-select-option :value="item.id" v-for="item in (formList || [])" :key="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            label="表单明细">
            <a-tree-select
              style="width:100%"
              :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
              :treeData="addByFormModel.formItemList"
              :replaceFields="replaceFields2"
              v-model="addByFormModel.formItemIdList"
              :filterTreeNode="filterTreeNode"
              :treeCheckable="true"
              :showCheckedStrategy="showCheckedStrategy"
              :maxTagCount="10"
              placeholder="无">
            </a-tree-select>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>    
    <a-modal
      :visible="isDeleteVisible"
      title="确认删除"
      @cancel="isDeleteVisible = false"
      :footer="null">
      <p>
        已经有受试者入组并使用该题目进行随访，删除后该题目的受试者采集数据将无法导出，确认删除吗?
      </p>
      <!-- 使用 Vue 2 的 slot 语法 -->
      <div style="margin-top: 24px;">
        <a-button @click="deleteCancel" style="margin:0 8px;">取消</a-button>
        <a-button type="primary" @click="hideAction" style="margin:0 8px;">保留采集数据</a-button>
        <a-button type="danger" @click="deleteSubmit" style="margin:0 8px;">确定删除</a-button>
      </div>
    </a-modal>
  </a-drawer>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { postAction,getAction,putAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import baseRules from '@/constants/baseRules'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import JImageUpload from '@comp/jeecg/JImageUpload'
  import {
    TreeSelect
  } from 'ant-design-vue'
  export default {
    name: 'FormItemSet',
    components: { ATextarea,JImageUpload },
    mixins:[JeecgListMixin],
    data(){
      return {
        showCheckedStrategy: TreeSelect.SHOW_PARENT,
        expandedRowKeys:[],
        editModel:{},
        editRules:{
          isEdit:[baseRules.required],
          description:[baseRules.required],
        },
        editVisible:false,
        coppyId:'',
        edit:false,
        visible:false,
        rules:{
          number:[{}],
          category:[baseRules.requiredChange],
          elementId:[baseRules.requiredChange],
          sortNum:[baseRules.required],
          name:[baseRules.required],
          parentValueList:[baseRules.requiredChange],
          required:[baseRules.required],
          scale:[baseRules.required],
          conceal:[baseRules.required],
          disabled:[baseRules.requiredChange],
        },
        replaceFields:{children:'children', title:'name', key:'id',value:'id' },
        replaceFields2:{children:'children', title:'name', key:'id',value:'id' },
        formRecord:{},
        elTreeData:[
          {
            id: `-1`,
            name: `元素库`,
            category: '1',
            children: []
          }
        ],
        /* 排序参数 */
        isorter:{
          column: 'sortNum,createTime',
          order: 'asc,asc',
        },
        itemTreeData:[],
        // 表头
        columns: [

          {
            title: '题目',
            ellipsis: true,
            align:"left",
            width: 500,
            dataIndex: 'name'
          },
          {
            title: '题号',
            align:"center",
            width:200,
            dataIndex: 'number',
          },


          // {
          //   title: '元素名称',
          //   ellipsis: true,
          //   align:"center",
          //   dataIndex: 'elementName',
          // },
          {
            title: '必填',
            align:"center",
            dataIndex: 'required_dictText'
          },
          {
            title: '量表题目',
            align:"center",
            dataIndex: 'scale_dictText'
          },
          {
            title: '隐藏题目',
            align:"center",
            dataIndex: 'conceal_dictText'
          },
          {
            title: '依赖值',
            align:"center",
            dataIndex: 'parentValue'
          },
          {
            title: '元素库',
            align:"center",
            dataIndex: 'category',
            customRender:(text)=>{
              return text==='1'?'公共元素库':'项目元素库'
            }
          },
          {
            title: '排序',
            align:"center",
            dataIndex: 'sortNum'
          },
          {
            title: '',
            dataIndex: 'action2',
            width:35,
            align:"center",
            scopedSlots: { customRender: 'check' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:100,
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/project/projectFormItem/list",
          delete: "/project/projectFormItem/delete",
        },
        model:{},
        confirmLoading: false,
        disableMixinCreated:true,
        currentDictItems:[],
        expandedKeys: ['-1'],
        // 已有表单新增相关-------------
        addByFormVisible:false,
        isDeleteVisible: false,
        deleteId: '',
        addByFormModel:{},
        addByFormItemTreeData:[],
        formList:[],
        treeKey: 0,
        currentElementId: '',
      }
    },
    watch:{
      dataSource(){
        this.itemTreeData = JSON.parse(JSON.stringify(this.dataSource))
        this.addByFormItemTreeData = JSON.parse(JSON.stringify(this.dataSource))
        this.unDisabledAll(this.addByFormItemTreeData)
        this.handleEditMy(this.model || {})
      }
    },
    methods:{
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleEditCancel(){
        this.editVisible  = false
      },
      handleEditOk(){
        if(this.editModel.isEdit==='1'){
          this.confirmLoading = true
          putAction('/project/projectFormVersion/create',{
            projectId:this.formRecord.projectId,
            formId:this.formRecord.id,
            description: this.editModel.description
          }).then(res=>{
            if(res.success){
              this.$message.success(res.message)
              this.edit = true
              this.handleEditCancel()
            }else{
              this.$message.error(res.message)
            }
          }).catch(e=>{
            this.$message.error('未知异常'+e)

          }).finally(()=>{
            this.confirmLoading = false
          })
        }else{
          this.edit = true
          this.handleEditCancel()
        }

      },
      handleEditCreate(){
        this.editModel = {
          isEdit:'1',
        }
        this.editVisible  = true
      },
      close(){
        this.visible = false
        this.$emit('onClose')
      },
      view(formRecord,formList){
        this.formList = formList
        this.handleCancel()
        this.expandedKeys=['-1']
        this.formRecord = formRecord
        this.visible = true
        this.baseQueryParam = {formId:this.formRecord.id}
        this.elTreeData = [
          {
            id: `-1`,
            name: `元素库`,
            category: '1',
            children: []
          }
        ]
        this.loadData()
        this.handleAddMy()
      },
      getDefaultModel(){
        return {
          projectId:this.formRecord.projectId,
          formId:this.formRecord.id,
          sortNum:1,
          category:'1',
          required:'1',
          conceal:'0',
          disabled:'0',
          scale:'0',
        }
      },
      handleAddMy(){
        this.coppyId=''
        this.handleEditMy(this.getDefaultModel())
      },
      handleAddByFormCopy(record){
        this.addByFormModel = {
          formItemList:[],
          parentId:record.id,
          parentValueList:[],
          formId:'',
          formItemIdList:[],
          dictItems:[],
        }
        this.itemTreeChange2()
        this.addByFormVisible = true
      },
      handleAddMyCopy(record){
        this.coppyId=record.id
        const newRecord = JSON.parse(JSON.stringify(record))
        newRecord.sortNum = ((this.model.sortNum) || newRecord.sortNum)
        newRecord.id=null
        newRecord.createBy=null
        newRecord.createTime=null
        newRecord.updateBy=null
        newRecord.updateTime=null
        this.handleEditMy(newRecord)
      },
      handleEditMy(record){
        // console.log("this.elTreeData:"+ this.elTreeData)        
        this.$set(this.elTreeData[0],'children',[])
        this.treeKey += 1;
        let category = this.model.category
        this.model = Object.assign({},record)
        if(this.model.category!==category){
          this.currentElementId = record.elementId
          this.categoryChange()
        }
        
        console.log("model.elementId:"+ this.model.elementId)
        console.log("model.name:"+ this.model.name)
        if(this.model.parentValue){
          // this.$set(this.model,'parentValueList',this.model.parentValue.split(','))
          this.$set(this.model,'parentValueList',this.model.parentValue.split(','))
          // this.model.parentValueList =
        }else{
          this.$set(this.model,'parentValueList',[])
        }
        this.unDisabledAll(this.itemTreeData)
        if(this.model.id){
          this.coppyId=''
          this.disabledNode(this.itemTreeData,this.model.id,false)
          this.itemTreeChange()
        }
        this.elTreeChange()
        console.log("this.model.draw:"+this.model.draw)
        this.$set(this.model,'draw',(this.model.draw || 0) + "")
      },
      elTreeChange(){
        if(!this.model.name){
          const node = this.getTreeNode(this.elTreeData,this.model.elementId)
          if(node){
            this.$set(this.model,'name',node.name)
          }
        }
      },
      concealChange(){}
      ,
      categoryChange(){        
        let httpurl = ''
        if(this.model.category==='1'){
          httpurl = '/project/projectElement/publicList'
        }else if(this.model.category==='2'){
          httpurl = '/project/projectElement/list?projectId='+this.formRecord.projectId
        }else{
          return
        }
        this.expandedKeys=['-1']
        this.elTreeData = [
          {
            id: `-1`,
            name: `元素库`,
            category: '1',
            children: [],
          }
        ]
        this.onLoadTreeDataAction(this.elTreeData[0])
        // getAction(httpurl).then(res=>{
        //   if(res.success){
        //     this.elTreeData[0].children = res.result
        //     this.disabledParentNode(this.elTreeData)
        //   }
        // })
      },
      onLoadTreeDataAction(parentNodeData,callBack){
        const parentId = parentNodeData.id==='-1'?null:parentNodeData.id
        let currentId = this.currentElementId || this.model.elementId
        let httpurl = ''
        if(this.model.category==='1'){
          httpurl = '/project/projectElement/publicList?currentId='+currentId
        }else if(this.model.category==='2'){
          httpurl = '/project/projectElement/list2?projectId='+this.formRecord.projectId+'&currentId='+currentId
        }else{
          return
        }
        getAction(httpurl,{parentId:parentId}).then(res=>{
          if(res.success){
            parentNodeData.children = res.result
            if(callBack){
              callBack()
            }
            this.$nextTick(()=>{
              this.disabledParentNode(parentNodeData)
            })
          }
        })
      },
      onLoadTreeData(treeNode){
        return new Promise((resolve)=>{
          const parentNodeData =treeNode.dataRef
          this.onLoadTreeDataAction(parentNodeData,resolve)
        })
      },
      handleCancel(){
        this.model={}
        this.edit=false
      },
      handleSubmit(){
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let formData = JSON.parse(JSON.stringify(this.model));
            let parentValue=''
            if(formData.parentValueList && formData.parentValueList.length>0){
              formData.parentValueList.forEach(item=>{
                parentValue+=item+','
              })
            }
            if(parentValue.length>0){
              parentValue = parentValue.substring(0,parentValue.length-1)
            }
            formData.parentValue = parentValue || null
            postAction('/project/projectFormItem/saveOrUpdate',formData).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                if(!formData.id){
                  let sortNum = this.model.sortNum;
                  this.model.sortNum = sortNum+1
                }
                this.loadData()
                // this.handleCancel()
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          } else {
            return false;
          }
        })
      },
      filterTreeNode(inputValue, treeNode){
        return treeNode.data.props.title && treeNode.data.props.title.toLowerCase().indexOf(inputValue.toLowerCase())>=0
      },
      disabledParentNode(nodeList){
        if(nodeList&&nodeList.length>0){
          nodeList.forEach(node=>{
            if(node.category==='1'){
              node.disabled = true
              this.disabledParentNode(node.children)
            }
          })
        }
      },
      unDisabledAll(nodeList){
        if(!nodeList || nodeList.length===0){
          return
        }
        nodeList.forEach(node=>{
          node.disabled = false
          if(node.children){
            this.unDisabledAll(node.children)
          }
        })
      },
      disabledNode(nodeList,id,disabledChildren){
        if(!nodeList || nodeList.length===0){
          return
        }
        if(disabledChildren){
          nodeList.forEach(node=>{
            node.disabled = true
            if(node.children){
              this.disabledNode(node.children,id,true)
            }
          })
        }else{
          nodeList.forEach(node=>{
            if(node.id===id){
              node.disabled = true
              if(node.children){
                this.disabledNode(node.children,id,true)
              }
            }
            else{
              if(node.children){
                this.disabledNode(node.children,id,false)
              }
            }
          })
        }
      },
      itemTreeChange(){
        if(this.model.parentId){
          this.currentDictItems = []
          getAction('/project/projectFormItem/queryById',{id:this.model.parentId}).then(res=>{
            if(res.success){
              if(res.result.element && res.result.element.dictItemList && res.result.element.dictItemList.length>0){
                this.currentDictItems = res.result.element.dictItemList
              }
            }
          })
        }else{
          this.model.parentValueList = []
          this.currentDictItems = []
        }
      },
      itemTreeChange2(){
        if(this.addByFormModel.parentId){
          this.addByFormModel.dictItems = []
          getAction('/project/projectFormItem/queryById',{id:this.addByFormModel.parentId}).then(res=>{
            if(res.success){
              if(res.result.element && res.result.element.dictItemList && res.result.element.dictItemList.length>0){
                this.addByFormModel.dictItems = res.result.element.dictItemList
              }
            }
          })
        }else{
          this.model.parentValueList = []
          this.currentDictItems = []
        }
      },
      customRowFn(record) {
        return {
          on: {
            dblclick: () => {
              if(this.expandedRowKeys.indexOf(record.id)<0){
                this.expandedRowKeys.push(record.id)
              }
            }
          }
        }
      },
      getTreeNode(nodeList,id){
        let result = null
        if(nodeList){
          nodeList.forEach(node=>{
            if(result!==null){
              return
            }
            if(node.id===id){
              result = node

            }else{
              if(node.children&&node.children.length>0){
                result = this.getTreeNode(node.children,id)
              }
            }
          })
        }
        return result
      },
      formIdChange(){
        this.addByFormModel.formItemIdList = []
        this.confirmLoading = true
        getAction('/project/projectFormItem/list',{formId:this.addByFormModel.formId}).then(res=>{
          if(res.success){
            this.unDisabledAll(res.result)
            this.addByFormModel.formItemList = res.result
          }
        }).finally(()=>{
          this.confirmLoading = false
        })
      },
      handleAddByFormOk(){
        if(this.addByFormModel.formItemIdList.length==0){
          return this.$message.warning('请选择至少一项表单明细')
        }
        if(this.addByFormModel.parentId && this.addByFormModel.parentValueList.length==0){
          return this.$message.warning('请选择依赖项值')
        }
        this.confirmLoading = true
        const params = {
          parentId: this.addByFormModel.parentId,
          parentValue: this.addByFormModel.parentValueList.join(','),
          formId: this.formRecord.id,
          formItemIds: this.addByFormModel.formItemIdList.join(','),
        }
        postAction('/project/projectFormItem/addByFormItem',params).then(res=>{
          if(res.success){
            this.loadData();
            this.handleAddByFormCancel()
          }else{
            this.$message.error(res.message)
          }
        }).finally(()=>{
          this.confirmLoading = false
        })
      },
      handleSetNum(){
        this.$confirm({
          title: '确认自动设置题号吗',
          content: '确认自动设置题号吗？',
          onOk:()=> {
            this.confirmLoading = true
            postAction('/project/projectFormItem/resetNum',{formId:this.formRecord.id}).then(res=>{
              if(res.success){
                this.loadData();
              }
            }).finally(()=>{
              this.confirmLoading = false
            })
          },
        });

      },
      handleResetSortNum(){
        this.$confirm({
          title: '确认自动排序吗',
          content: '确认自动排序吗？',
          onOk:()=> {
            this.confirmLoading = true
            postAction('/project/projectFormItem/resetSortNum',{formId:this.formRecord.id}).then(res=>{
              if(res.success){
                this.loadData();
              }
            }).finally(()=>{
              this.confirmLoading = false
            })
          },
        });

      },
      handleAddByFormCancel(){
        this.addByFormVisible = false
      },
      handleDelete2(id){
        getAction('/project/projectFormItem/isVisitForm',{formItemId:id}).then(res=>{
          if(res.success){
            if(res.result){
              this.deleteId = id
              this.isDeleteVisible = true              
            }else{
              this.isDeleteVisible = false
              //不存在表单题目采集数据，直接删除
              this.handleDelete(id)
            }
          }else{
            this.$message.warning(res.message)
          }
        }).finally(()=>{
          
        })
      },
      deleteCancel() {
        this.isDeleteVisible = false;
      },
      deleteSubmit() {
        console.log('执行删除');
        this.handleDelete(this.deleteId)
        this.isDeleteVisible = false;
      },
      hideAction() {
        console.log('保留采集数据，隐藏题目');
        var that = this;
        getAction('/project/projectFormItem/hideFormItem',{formItemId:this.deleteId}).then(res=>{
          if(res.success){
            if(res.result){
              this.$message.success("执行成功！")
              that.loadData();
              that.handleAddMy()
              this.isDeleteVisible = false              
            }else{
              this.$message.warning("执行失败！")
            }
          }else{
            this.$message.warning(res.message)
          }
        }).finally(()=>{
          
        })
        this.isDeleteVisible = false;
      }
    }
  }
</script>

<style scoped>
  .table{
    max-height: calc(100vh - 205px);
    overflow-y: auto;
  }
</style>